import {ITrailerJson} from "../../../../../nodeserver/structs/database";
import JSX from "../../helpers/react.js";
import {ISelectValue, Select} from "../elements/Select.js";
import {TrailerPlayerSelect} from "./TrailerPlayerSelect.js";
import RefObject = JSX.RefObject;
import {TrailerBlockContent} from "./TrailerBlockContent.js";


export function TrailersPage({trailers}: {trailers: ITrailerJson[]}){
    const dubbings = Array.from(new Set(trailers.map(e=>e.dubbing)));
    const players = Array.from(new Set(trailers.map(e=>e.player)));
    const playerSelect: RefObject = {};
    const videoBlockContent: RefObject = {};

    const ans =  (
        <div className="trailer">
            {
                (dubbings.length > 1 || players.length > 1) ?
                <div className="video-block-select" style={{display: 'flex'}}>
                    <Select name="dubbing-select" multiple={false} placeholder="Dubbing" onChange={element=>setTimeout(()=>selectDubbing(element!.value! as number))}>
                        {
                            ...dubbings.map(
                                (dubbing, index) => ({
                                    value: index,
                                    name: dubbing,
                                    selected: index == 0
                                } as ISelectValue)
                            )
                        }
                    </Select>
                    <div id="player-select" ref={playerSelect}>
                        {
                            ...dubbings.map((dubbing, index) => (
                                <TrailerPlayerSelect
                                    players={Array.from(new Set(trailers.filter(e=>e.dubbing === dubbing).map(e=>e.player)))}
                                    index={index}
                                    onSelect={(player)=>setTimeout(()=>onPlayerSelect(player, dubbing))}/>
                            ))
                        }
                    </div>
                </div>
                : void setTimeout(()=>onPlayerSelect(players[0], dubbings[0]))
            }
            <div className="video-block-content" ref={videoBlockContent} style={{paddingTop: '10px'}}/>
        </div>
    );
    // setTimeout(()=>onPlayerSelect(players[0], dubbings[0]))
    return ans;
    function selectDubbing(dubbingIndex: number){
        const children = Array.from(playerSelect.value!.children) as HTMLElement[];
        for(const ch of children)
            ch.style.display="none";
        children.find(e=>(e as HTMLElement).dataset.dub == dubbingIndex+"")!.style.display = 'flex';
        onPlayerSelect(trailers.find(dubbing=>dubbing.dubbing == dubbings[dubbingIndex])!.player, dubbings[dubbingIndex],)
    }

    function onPlayerSelect(player: string, dubbing: string){
        videoBlockContent.value!.innerText = '';
        const trailersFiltered = trailers.filter(e=>e.player === player && e.dubbing === dubbing);
        videoBlockContent.value!.appendChild(
            <TrailerBlockContent trailers={trailersFiltered}/>
        );
    }
}
